export const FETCH_DEALER_ASSOCIATION_TAG = 'FETCH_DEALER_ASSOCIATION';

export const GENERIC_ERROR = 'GENERIC_ERROR';

export const DEALER_ASSOCIATION_FAULT_INJECT = {
  type: 'faultInject_dealerAssociation',
  genericError: GENERIC_ERROR
};

export const CHANGE_STORE_LOCATION_FAULT_INJECT = {
  type: 'faultInject_change_store',
  genericError: GENERIC_ERROR
};

export const SUBMIT_ADP_CSR_FAULT_INJECT = {
  type: 'faultInject_submitADP_CSR',
  genericError: GENERIC_ERROR
};

export const LOGIN_FROM_HP = 'loginFromHomePage';

export const RP_COOKIE = 'rp';

export const ESI_COOKIE = 'esi';

export const SIS_PARTS_LIST_COOKIE = 'sisPartsList';
